import { z } from 'zod';

import { clientIdSchema, personIdSchema } from './ids';

// Each code is the `message` of a 409 whose `details`, where it has any, match the schema beside it.
export const EMAIL_IN_USE = 'EMAIL_IN_USE';

export const emailInUseDetailsSchema = z.object({
    holder: z.discriminatedUnion('kind', [
        z.object({
            kind: z.literal('CLIENT'),
            clientId: clientIdSchema,
            personId: personIdSchema,
            name: z.string(),
            ownedByYou: z.boolean(),
        }),
        z.object({
            kind: z.literal('CONTACT'),
            clientId: clientIdSchema,
            personId: personIdSchema,
            name: z.string(),
            clientName: z.string(),
        }),
    ]),
});

export type EmailInUseDetails = z.infer<typeof emailInUseDetailsSchema>;

export const CONTACT_DETAILS_LOCKED = 'CONTACT_DETAILS_LOCKED';

export const contactDetailsLockedDetailsSchema = z.object({
    fields: z.array(z.enum(['emailPrimary', 'phonePrimary', 'address'])).min(1),
});

export type ContactDetailsLockedDetails = z.infer<typeof contactDetailsLockedDetailsSchema>;

// Carried by `client/attach-contact` alone: the therapist already has the person selected, so
// there is nothing to name in it.
export const PERSON_ALREADY_ON_CLIENT = 'PERSON_ALREADY_ON_CLIENT';
